import type {RouteObject} from 'react-router-dom';
import {Layout} from '~/sections/shared-entity/layout';
import {SharedEntity} from '~/sections/shared-entity/shared-entity';
import {ErrorScreen} from '~/components/error-screen';
import {RouteErrorBoundary} from './route-error-boundary';

export const routes: RouteObject = {
  ErrorBoundary: RouteErrorBoundary,
  children: [
    {
      path: '/:identifier',
      element: <Layout />,
      children: [
        {
          index: true,
          element: <SharedEntity />,
          // Catching here keeps the Layout, and with it the auth session, alive
          // when the entity query fails; the root boundary would tear both down
          // and drop whatever the session was mid-way through resolving.
          ErrorBoundary: RouteErrorBoundary,
        },
      ],
    },
    {
      path: '*',
      element: (
        <ErrorScreen
          title="Not found"
          message="The page you're looking for doesn't exist."
        />
      ),
    },
  ],
};
